import * as React from 'react';

import IconCollections from './IconCollections';

export const collections = () => <IconCollections />;

export default {
    title: 'Icons/Collections/Collections',
    component: IconCollections,
    parameters: {
        notes: "`import IconCollections from 'box-ui-elements/es/icons/collection/IconCollections';`",
    },
};
